import React, { useEffect, useState } from 'react'
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer,
} from '@paypal/react-paypal-js'

interface PayPalProps {
  clientId: string
  createOrderApiUrl: string
  onApproveApiUrl: string
  selectedAmount: number
  isRecurring: boolean
  isDisabled: boolean
  currencyCode?: string
  formId: number
}

const PayPalDonateButton: React.FC<PayPalProps> = ({
  clientId,
  createOrderApiUrl,
  onApproveApiUrl,
  selectedAmount,
  isRecurring = false,
  isDisabled,
  currencyCode,
  formId,
}) => {

  const [requestVerificationToken, setRequestVerificationToken] = useState<string | null>(null);
  const style = { layout: 'vertical' }

  useEffect(() => {
    const tokenInput = document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement;
    if (tokenInput) {
      setRequestVerificationToken(tokenInput.value);
    }
  }, []);

    const createSubscription = (data: any, actions: any) => {
        return fetch(createOrderApiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Requestverificationtoken': requestVerificationToken || '',
            },
            body: JSON.stringify({
                amount: selectedAmount,
                currency: currencyCode,
                formId,
                isRecurring,
                currentUrl: window.location.href
            })
        })
        .then(response => response.json())
        .then(order => order.orderId)
        .then(orderId => {
            return actions.subscription.create({
                'plan_id': orderId
            });
        });
    }

  const createOrder = () => {
    return fetch(createOrderApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Requestverificationtoken': requestVerificationToken || '',
      },
      body: JSON.stringify({
        amount: selectedAmount,
        currency: currencyCode,
        formId,
        isRecurring,
        currentUrl: window.location.href
      })
    })
      .then(response => response.json())
      .then(order => order.orderId);
    }

    const onApprove = (data: any) => {
    return fetch(onApproveApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Requestverificationtoken': requestVerificationToken || '',
      },
      body: JSON.stringify({
          orderId: isRecurring ? data.subscriptionID : data.orderID,
          amount: selectedAmount,
          currency: currencyCode,
          formId,
          isRecurring,
          currentUrl: window.location.href
      })
    })
      .then(response => response.json())
        .then(details => {
        if (details.redirectUrl) {
          window.location.href = details.redirectUrl;
        }
      });
  }
  // Custom component to wrap the PayPalButtons and show loading spinner
  const CustomPaypalButton = ({ showSpinner }: { showSpinner: boolean }) => {
    const [{ isPending }] = usePayPalScriptReducer()

    return (
      <>
        {showSpinner && isPending && <div className='spinner' />}
          {isRecurring ? (
            <PayPalButtons
              fundingSource='paypal'
              style={{
                layout: 'vertical',
                label: 'donate',
                disableMaxWidth: true,
              }}
              disabled={isDisabled}
              forceReRender={[style]}
              createSubscription={createSubscription}
              onApprove={onApprove}
              className='paypal-button-internal'
              />
            ) : (
            <PayPalButtons
              fundingSource='paypal'
              style={{
                layout: 'vertical',
                label: 'donate',
                disableMaxWidth: true,
              }}
              disabled={isDisabled}
              forceReRender={[style]}
              createOrder={createOrder}
              onApprove={onApprove}
              className='paypal-button-internal'
            />
          )}
      </>
    )
  }

  return (
    <PayPalScriptProvider
      options={{ clientId: clientId, components: 'buttons', currency: currencyCode, vault: isRecurring }}>
      <CustomPaypalButton showSpinner={false} />
    </PayPalScriptProvider>
  )
}

export default PayPalDonateButton
